export const isLocalhost = () =>
  import.meta.env.VITE_PUBLIC_NAME === "localhost";
